/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Projects_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not update linked projects." |
*
* @param {Linked_Projects_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const linked_projects_save_error = /** @type {((inputs?: Linked_Projects_Save_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Projects_Save_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfte Projekte konnten nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Could not update linked projects.")
});